import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react'
import { extendTheme } from "@chakra-ui/react"
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('hpls-app-form'));

const theme = extendTheme({
  fonts: {
    heading: `'Inter', sans-serif`,
    body: `'Inter', sans-serif`,
  },
  colors: {
    piacred: {
      100: "#f5d1cd",
      500: "#A21D36",
      900: "#6b1424",
    },
    piacblue: {
      100: "#ccf6f6f6",
      200: "#ccf0f0",
      500: "#5B89B4",
      600: "#3b5998",
      700: "#30497c",
      800: "#2272a6",
      900: "#115096",
    },
    piacyellow: {
      100: "#fccf79",
      500: "#F5A81C",
      900: "#c48000",
    },
    piacgray: {
      100: "#f6f6f9",
      200: "#fcfcff",
      300: "#e0e0e6",
      400: "#404046",
      500: "#5c5d5b",
      900: "#6b1424",
    },
    focusBorderColor: "piacblue.500",
  },
  styles: {
    global: {
      body: {
        bg: 'white',
        color: '#333432',
        fontWeight: '400',
        lineHeight: 1.5,
        fontFamily: ['Inter', 'sans-serif'],
        accentColor: '#A21D36',
      },
      input: {
        appearance: 'none',
        width: '1.2rem',
        height: '1.2rem',
        verticalAlign: 'middle',
        _focus: {
          boxShadow: "1px 1px 1px #808080",
        },
        _focusVisible: {
          color: "black",
          background: "piacgray.100",
          fontWeight: "600",
          boxShadow: "2px 2px 4px #808080",
        },
        },
      a: {
        color: '#5B89B4',
        fontWeight: '600',
        _hover: {
          textDecoration: 'none',
          color: '#4c7296',
        },
      },
    },
  },
})
export default theme

root.render(
  // <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  // </React.StrictMode>
);


